import { ThemeColor } from '@/enums'
import { RatingStarIcon } from '@/icons'
import { isFloat } from '@/utils'
import { range } from 'ramda'
import { useEffect, useRef } from 'react'
import { Row } from '../../styled'
import { Typography } from '../Typography'
import { Container } from './styles'

export interface RatingProps {
  min?: number
  max?: number
  value: number
  reverse?: boolean
  ratingAmount?: number
  iconSize?: number
}

const SIZE = 16

const makeRectX = (value: number): number => {
  const multiplied = value * 10
  const intVal = parseInt(String(multiplied), 10)
  const mod = intVal % 10
  const scaled = mod * SIZE
  return scaled / 10
}

export const Rating = ({
  min = 1,
  max = 5,
  value = 0,
  reverse,
  ratingAmount,
  iconSize = 16,
}: RatingProps) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current && isFloat(value)) {
      const notFullStar = ref.current.children[Math.ceil(value)]

      const clipPath = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'clipPath',
      )
      clipPath.setAttribute('id', 'cp')

      const rect = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'rect',
      )
      rect.setAttribute('height', SIZE.toString())
      rect.setAttribute('width', SIZE.toString())
      rect.setAttribute('x', makeRectX(value).toString())
      rect.setAttribute('y', '0')

      clipPath?.appendChild(rect)
      notFullStar?.appendChild(clipPath)

      const use = document.createElementNS('http://www.w3.org/2000/svg', 'use')
      use.setAttribute('clip-path', 'url(#cp)')
      use.setAttribute('href', '#star-icon')

      notFullStar?.appendChild(use)
    }
  }, [])

  return (
    <Container reverse={reverse}>
      <Typography variant="badgeText">
        {value.toFixed(1)}
        {ratingAmount && ` (${ratingAmount})`}
      </Typography>
      <Row ref={ref} gap="4px">
        {range(min, max + 1).map((val) => (
          <RatingStarIcon
            key={val}
            color={
              Math.ceil(value) >= val
                ? ThemeColor.warning1
                : ThemeColor.warning3
            }
            size={iconSize}
            stroke
          />
        ))}
      </Row>
    </Container>
  )
}
